export default "<div class=\"cssload-container-home\">\n  <div class=\"cssload-double-torus-home\"></div>\n</div>\n"